module.exports = __webpack_public_path__ + "e990eca16cc860f3fb7a4cfbd5228cad.svg";